<template>
  <div class="slot-box">
    <template v-if="list[0] && isLarge(list[0].type)">
      <div class="net-work-row flex-layout max-work-row" style="align-items: center">
        <div class="net-work-port" v-for="(item, index) in list" :key="index">
          <div class="port-item port-item-one slot-item" :style="calcStyle(item.portNum)">
            <el-popover
              placement="top"
              popper-class="sakura-child-port-popover"
              trigger="click"
              :disabled="!checkFanout(item.portNum)"
              @show="() => fanoutChange(item.portNum)"
              @hide="() => fanoutChange()"
              :visible="popoverControl[item.portNum]"
            >
              <sakura-child-panel
                :list="fanout.filter(obj => obj.rootPortNum === item.portNum)"
                :popover="popover"
                :value="value"
                :multiple="multiple"
                :isEnabled="isEnabled"
                :isEnabledTu="isEnabledTu"
                @change="onChildSelectChange"
              />
              <template #reference>
                <div @click="handlePortClick(item)" style="cursor: pointer; height: 100%;">
                  <sakura-port-lan-large
                    @port-click="() => emit('port-click', item)"
                    @port-click-fanout="() => emit('port-click-fanout', item)"
                    @change="num => emit('change', num, item)"
                    :type="item.type"
                    :isEnabledTu="isEnabledTu && item.isEnabledTu"
                    :tu="item.tu"
                    @update:tu="val => item.tu = val"
                    :value="item.selected"
                    :port="item.portNum"
                    :popover="popover"
                    :isEnabled="isEnabled && item.isEnabled"
                    :status="item.status"
                    :borderStatus="item.borderStatus"
                    v-model="item.selected"
                    :hex="item.hex"
                    :mode="item.mode"
                    :lag="item.lag"
                    :priority="item.priority"
                    :vendor="item.detect"
                    :config="item.config"
                    :isFanout="checkFanout(item.portNum)"
                  >
                    {{ item.value }}
                  </sakura-port-lan-large>
                </div>
              </template>
            </el-popover>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <!-- Even index ports -->
      <div class="net-work-row flex-layout" style="align-items: center">
        <div class="net-work-port" v-for="(item, index) in list.filter((dataType, index) => !(index % 2))" :key="index">
          <div class="port-item port-item-one" :style="calcStyle(item.portNum)">
            <el-popover
              placement="top"
              popper-class="sakura-child-port-popover"
              trigger="click"
              :disabled="!checkFanout(item.portNum)"
              @show="() => fanoutChange(item.portNum)"
              @hide="() => fanoutChange()"
            >
              <sakura-child-panel
                :list="fanout.filter(obj => obj.rootPortNum === item.portNum)"
                :popover="popover"
                :value="value"
                :multiple="multiple"
                :isEnabled="isEnabled"
                :isEnabledTu="isEnabledTu"
                @change="(num, obj) => emit('change', num, obj)"
              />
              <template #reference>
                <sakura-port-lan
                  @change="num => emit('change', num, item)"
                  :type="item.type"
                  :isEnabledTu="isEnabledTu && item.isEnabledTu"
                  :tu="item.tu"
                  @update:tu="val => item.tu = val"
                  :value="item.selected"
                  :port="item.portNum"
                  :popover="popover"
                  :isEnabled="isEnabled && item.isEnabled"
                  :status="item.status"
                  :borderStatus="item.borderStatus"
                  v-model="item.selected"
                  :hex="item.hex"
                  :mode="item.mode"
                  :lag="item.lag"
                  :priority="item.priority"
                  :vendor="item.detect"
                  :config="item.config"
                  :isFanout="checkFanout(item.portNum)"
                >
                  {{ item.value }}
                </sakura-port-lan>
              </template>
            </el-popover>
          </div>
        </div>
      </div>

      <!-- Odd index ports -->
      <div class="net-work-row flex-layout" style="align-items: center">
        <div class="net-work-port" v-for="(item, index) in  list.filter((dataType, index) => (index % 2))" :key="index">
          <div class="port-item port-item-one" :style="calcStyle(item.portNum)">
            <el-popover
              placement="top"
              popper-class="sakura-child-port-popover"
              trigger="click"
              :disabled="!checkFanout(item.portNum)"
              @show="() => fanoutChange(item.portNum)"
              @hide="() => fanoutChange()"
            >
              <sakura-child-panel
                :list="fanout.filter(obj => obj.rootPortNum === item.portNum)"
                :popover="popover"
                :value="value"
                :multiple="multiple"
                :isEnabled="isEnabled"
                :isEnabledTu="isEnabledTu"
                @change="(num, obj) => emit('change', num, obj)"
              />
              <template #reference>
                <sakura-port-lan
                  @change="num => emit('change', num, item)"
                  :type="item.type"
                  :isEnabledTu="isEnabledTu && item.isEnabledTu"
                  :tu="item.tu"
                  @update:tu="val => item.tu = val"
                  :value="item.selected"
                  :port="item.portNum"
                  :popover="popover"
                  :isEnabled="isEnabled && item.isEnabled"
                  :status="item.status"
                  :borderStatus="item.borderStatus"
                  v-model="item.selected"
                  :hex="item.hex"
                  :mode="item.mode"
                  :lag="item.lag"
                  :priority="item.priority"
                  :vendor="item.detect"
                  :config="item.config"
                  :isFanout="checkFanout(item.portNum)"
                >
                  {{ item.value }}
                </sakura-port-lan>
              </template>
            </el-popover>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import {inject, onBeforeUnmount, onMounted, ref} from 'vue'
import sakuraPortLan from './sakura-port-lan.vue'
import sakuraPortLanLarge from './sakura-port-lan-large.vue'
import sakuraChildPanel from './sakura-child-panel.vue'

const props = defineProps({
  popover: { type: Boolean, default: false },
  value: { type: Array, default: () => [] },
  multiple: { type: Boolean, default: true },
  isEnabled: { type: Boolean, default: true },
  isEnabledTu: { type: Boolean, default: false },
  list: { type: Array, default: () => [] },
  fanout: { type: Array, default: () => [] }
})

const popoverControl = ref({})
const root = ref(null)

const emit = defineEmits(['change', 'port-click', 'port-click-fanout'])

const network = inject('network', null)

const calcStyle = () => {
  const obj = {}
  if (popoverControl.value[network.fanoutNum]) {
    obj.filter = 'blur(3px)'
    obj['pointer-events'] = 'none'
  }
  return obj
}

const checkFanout = (port) => {
  return props.fanout && props.fanout.length && props.fanout.find(item => item.rootPortNum === port)
}

const fanoutChange = (num = null) => {
  network.fanoutNum = num
}

function handlePortClick(item) {
  for (const key in popoverControl.value) {
    popoverControl.value[key] = false
  }
  if (!checkFanout(item.portNum)) {
    network.fanoutNum = null
    return
  }
  popoverControl.value[item.portNum] = true
  network.fanoutNum = item.portNum
}
function onChildSelectChange(num, obj) {
  emit('change', num, obj)
  popoverControl.value[network.fanoutNum] = true
}


const isLarge = (type) => {
  return ['plus', 'hdmi'].includes(type)
}

function nodeInPathMatches(path, selector) {
  if (!path) return false;
  for (const node of path) {
    if (!node || node.nodeType !== 1) continue;
    try {
      if (node.matches(selector)) return true;
    } catch { /* ignore invalid node types */ }
  }
  return false;
}


function handleGlobalClick(e) {
  const target = e.target;
  const path = (e.composedPath && e.composedPath()) || (function buildPath(n) {
    const p = [];
    while (n) { p.push(n); n = n.parentNode; }
    return p;
  })(target);

  if (nodeInPathMatches(path, '.el-select, .el-select__trigger, .el-select__popper, .el-select-dropdown, .el-select .el-input')) {
    return;
  }

  if (nodeInPathMatches(path, '.manual_trunk_select-popper, .profile_select-popper')) {
    return;
  }

  if (nodeInPathMatches(path, '.sakura-child-port-popover')) {
    return;
  }

  if (nodeInPathMatches(path, '.sakura-port-panel, .page-network-container, .slot-body, .slot-box')) {
    if (network) {
      network.fanoutNum = null;
    }
    return;
  }

  if (nodeInPathMatches(path, '.sakura-port-popover')) {
    if (network) network.fanoutNum = null;
    return;
  }

  if (root.value && root.value.contains(target)) {
    return;
  }

  for (const k in popoverControl.value) popoverControl.value[k] = false;
  if (network) network.fanoutNum = null;
}


onMounted(() => {
  document.addEventListener("click", handleGlobalClick)
})
onBeforeUnmount(() => {
  document.removeEventListener("click", handleGlobalClick)
})
</script>



<style lang="scss" scoped>
@use "@/css/base.scss" as *;

.net-work-row {
  height: 50px;
}

.max-work-row {
  height: 100px;
}

.net-work-port {
  flex: 1;
  height: inherit;
  min-width: 50px;

  .port-item {
    height: 100%;
    line-height: 100px;
    text-align: center;
    position: relative;
  }

  .port-item-one {
    border-right: 1px solid $network-border-color;
    border-bottom: 1px solid $network-border-color;
  }

  .port-item-two {
    border-right: 1px solid $network-border-color;
  }

  .port-item port-item-one:last-child,
  .port-item port-item-two:last-child {
    border-right: none;
  }
}

.slot-item {
  min-width: 50px;
}
:deep(.all-slot) {
    width: 224px !important;
    min-width: inherit;
}
</style>
